 const INSTRUCTIONS =  {
    gallery:[
        'Choose a high-quality image with good lighting',
        'Make sure your face is clearly visible in the photo',
        'Crop the photo to include only your head and shoulders',
        'The image should have a neutral background and be in color',
        'Ensure the photo is not blurred or distorted',
        'Select an image that represents your current appearance'
    ],
    webcam:[
        'Stand in front of a plain background with good lighting',
        'Position yourself facing the camera directly',
        'Ensure your face is fully visible without any obstructions',
        'Maintain a neutral facial expression and look directly at the camera',
        'Adjust the face to include only your head and shoulders',
        'White background would be a better option for more accuracy',
    ]
};


export default {
    ...INSTRUCTIONS
  };